import { DEFAULT_VALUE } from "@supplier/constants";

// 金额工具类

function isNumber(val: unknown): val is number {
    return Object.prototype.toString.call(val) === `[object Number]`;
}
// 格式化金额 后端数据转前端金额 字符串展示
export function formatMoney(transactionAmount: number | null | undefined, ratio: number = 1, digits: number = 2): string {
    if (isNumber(transactionAmount)) {
        return Number(transactionAmount / ratio).toFixed(digits);
    }
    return DEFAULT_VALUE;
}

// 格式化金额 前端金额转后端数据 数字数据
export function formatAmount(transactionMoney: number | null, ratio: number = 1): number {
    if (isNumber(transactionMoney)) {
        return Number(transactionMoney * ratio);
    }
    return 0;
}

// 格式化金额 带千分位符
export function formatMoneyDigitGrouping(transactionAmount: number | null): string {
    if (transactionAmount && isNumber(transactionAmount)) {
        return transactionAmount
            .toLocaleString("zh-CN", {
                style: "currency",
                currency: "CNY"
            })
            .replace("¥", "");
    }
    return DEFAULT_VALUE;
}

export function digitUppercase(n: number): string {
    const fraction: string[] = ["角", "分"];
    const digit: string[] = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
    const unit: string[][] = [
        ["元", "万", "亿"],
        ["", "拾", "佰", "仟"]
    ];
    const head: string = n < 0 ? "负" : "";
    n = Math.abs(n);
    let s: string = "";
    for (const [i, element] of fraction.entries()) {
        s += (digit[Math.floor(n * 10 * 10 ** i) % 10] + element).replace(/零./, "");
    }
    s = s || "整";
    n = Math.floor(n);
    for (let i = 0; i < unit[0].length && n > 0; i++) {
        let p: string = "";
        for (let j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
    }
    return (
        head +
        s
            .replace(/(零.)*零元/, "元")
            .replace(/(零.)+/g, "零")
            .replace(/^整$/, "零元整")
    );
}
